const accordionHeaders = document.querySelectorAll('.trainer__list-header')

accordionHeaders.forEach(btn => {
	btn.addEventListener('click', () => {
		const isOpen = btn.getAttribute('aria-expanded') === 'true'

		// Zamknij wszystkie
		accordionHeaders.forEach(b => {
			b.setAttribute('aria-expanded', 'false')
			b.nextElementSibling.classList.remove('trainer__list-body--open')
		})

		// Otwórz kliknięty (jeśli był zamknięty)
		if (!isOpen) {
			btn.setAttribute('aria-expanded', 'true')
			btn.nextElementSibling.classList.add('trainer__list-body--open')
		}
	})
})
